function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // var stringEl = $('.str3').liMarquee({
    //   scrollamount: 100,
    // })
    jQuery("#nav1").slide({
  mainCell: ".str3",
  autoPlay: true,
  effect: "leftMarquee",
  interTime: 8,
  vis: 1,
  scroll: 10,
});
     // let a = jQuery("#nav1").slide({
     //    mainCell: ".str3",
     //    autoPlay: true,
     //    effect: "leftMarquee",
     //    interTime: 8,
     //  });
    // 头部固定
    $('header').addClass('stiky')
    $(document).scroll(function (e) {
      var beforScrollTop = $(document).scrollTop()
      setTimeout(function () {
        $('header').addClass('stiky')
      }, 50)
    })
    // 字体轮播
    new Swiper('.mySwiperFree', {
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      loop: true,
    })
    new Swiper('#swiper2', {
      loop: true,
      centeredSlides: true,
      spaceBetween: 12,
      slidesPerView: 3,
      freeMode: true,
      speed: 5500, //匀速时间
      autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })
    // $('.sp-product-list li').each(function () {
    //   var index = $(this).index()
    //   var number = 1
    //   var plostNumber = 0
    //   if (index == 0) {
    //     number = 1
    //   } else if (index == 1) {
    //     number = 3
    //   } else if (index == 2) {
    //     number = 5
    //   } else if (index == 3) {
    //     number = 10
    //   }
    //   var price = $(this)
    //     .children('.sp-product-rl')
    //     .children()
    //     .children()
    //     .children()
    //     .html()
    //   plostNumber = Number(price / number)
    //     .toString()
    //     .replace(/(?<=\.\d{2}).*$/, '')
    //   if (
    //     $(this).children('.sp-product-rl').children().children('.save-texts')[0]
    //   ) {
    //     $(this)
    //       .children('.sp-product-rl')
    //       .children()
    //       .children('.save-texts')
    //       .html(plostNumber)
    //   }
    // })
    $(function () {
      // 倒计时的事件
      // 当前时间
      TimeDown(43200000)
      /*
       时间倒计时
       TimeDown.js
       */
      function TimeDown(value) {
        //倒计时的总秒数
        var totalSeconds = parseInt(value / 1000)
        //取模（余数）
        var modulo = totalSeconds % (60 * 60 * 24)
        //小时数
        var hours = Math.floor(modulo / (60 * 60))
        modulo = modulo % (60 * 60)
        //分钟
        var minutes = Math.floor(modulo / 60)
        //秒
        var seconds = modulo % 60

        hours = hours.toString().length == 1 ? '0' + hours : hours
        minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
        seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

        //输出到页面
        $('.hours').html(hours)
        $('.minutes').html(minutes)
        $('.seconds').html(seconds)
        //延迟一秒执行自己
        if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
        } else {
          setTimeout(function () {
            TimeDown(value - 1000)
          }, 1000)
        }
      }
    })
  })
  $('.link-btn').click(function(){
  let id = $(this).attr('data-id')
          window.location.href = '/cart/' + id + ':' + 1
})
  function addCart() {
    // 加入购物车
    $('#addCart').click(function () {
      // do something here
      var number = Number($('.buy-car span').html()) + Number($('#2').val())
      $('.buy-car span').html(number)
      var img = $('.sp-pro-img img')
      var flyer = img[0].cloneNode(true)
      flyer.classList.add('clone')
      $('.sp-part5').append(flyer)
      $('.clone').css({
        width: '796px',
        height: '711px',
        position: 'fixed',
        top: img[0].offsetTop,
        left: img.offset().left,
        'z-index': '99',
      })
      var offset = $('.buy-car')[0].getBoundingClientRect()
      $('.buy-car').addClass('shake')
      setTimeout(() => {
        $('.buy-car').removeClass('shake')
      }, 1000)
      let finish = $('.buy-car')
      $('.clone').animate(
        {
          top: offset.top + finish.height() / 2 / 2,
          left: offset.left + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        1000,
        'linear',
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach() // 完成动画后移除克隆的图片
            }
          )
        }
      )
    })
  }
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
